import * as React from "react";
import { Colors } from "../design-tokens/colors";
import { DeviceMargin, getMarginValue } from "../design-tokens/margin-helper";

interface SeparatorProps {
  margin?: DeviceMargin;
}

const Separator: React.FC<SeparatorProps> = ({ margin }) => {
  const marginValue = getMarginValue(margin);

  return (
    <hr
      css={[
        {
          borderTop: `1px solid ${Colors.BorderGrey}`,
        },
        marginValue,
      ]}
    />
  );
};

export default Separator;
